/**
 * ⟦C60 · A-177⟧ **Le grand ménage, côté écran : les interrupteurs, lus ICI et nulle part ailleurs.**
 *
 * Matt (03/10/2026) : *« Il faut tout simplifier, garder les grands principes. »* Le moteur lit les
 * interrupteurs dans `content/meta.json → systemes` (`@maxime/shared`, `engine/menage.ts`) ; l'écran
 * les lit exactement au même endroit, par ces deux fonctions, jamais en ouvrant `meta` lui-même :
 * un seul lecteur, un seul vocabulaire (`SystemeId`).
 *
 * `true` = le système est ACTIF = le jeu d'avant le ménage. Un contenu qui ne dit rien ne coupe
 * rien : les écrans que ce ménage cache se rallument en remettant le booléen à `true`, sans toucher
 * une ligne de React. Rien n'est supprimé, rien n'est réécrit : le code reste, inatteignable.
 *
 * Pur : aucune I/O, aucune horloge. `contenu()` est le bundle chargé une fois au boot.
 */

import { actionCost, systemes, type Action, type ActionCost, type GameState, type SystemeId, type Systemes } from "@maxime/shared";

import { contenu } from "./content";

/** Les interrupteurs du contenu chargé : un booléen « actif » par système, et le capital du Grand Saut. */
export function interrupteurs(): Systemes {
  return systemes(contenu());
}

/** Ce système est-il actif ? (`false` : coupé par le ménage, ses boutons, objets et écrans n'existent plus.) */
export function systemeOuvert(id: SystemeId): boolean {
  return interrupteurs()[id];
}

/**
 * ⟦C60 bis · A-177⟧ **Le coût d'une action, lu avec les réglages du contenu.** La thérapie (ses Clicks, son
 * énergie) et le respec (son prix de base) ne valent plus leur table d'avant : `content/meta.json → systemes`
 * les règle. Un écran qui affiche ou valide un coût DOIT passer par ici (même règle que le serveur, qui lit le
 * même `systemes(contenu)`) : afficher « 150 ₵ » là où le moteur débite 20 d'énergie serait un mensonge.
 * Contenu qui ne dit rien : la table d'avant, au caractère près.
 */
export function coutAction(action: Action, state: GameState): ActionCost {
  return actionCost(action, state, undefined, interrupteurs());
}
